export const STATE_NAME = "order";
export const FORM_NAME = STATE_NAME;
export const PAYMENT_METHOD_FORM_NAME = "paymentMethod";
